import React from 'react'
import { Link } from "react-router-dom";


const Facility = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Facility</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active" style={{ color: "red" }}>Facility</li>
                    </ul>
                </div>
            </div>

            <div className="about-area py-120">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-4">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                <div className="about-img">
                                    <div className="row g-4">
                                        <div className="col-md-12">
                                            <img className="img-2" src="assets/school/Computer Lab.webp" alt />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="about-right wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <div className="site-heading mb-3">
                                    <h2 className="site-title">
                                        Computer Lab
                                    </h2>
                                </div>
                                <p className="about-text" style={{ textAlign: "justify" }}>
                                    Our school has a well-equipped and modern Computer Lab designed to enhance students’ digital learning and technological skills. The lab provides a safe, structured, and innovative environment where students gain hands-on experience with computers and software.
                                    <br />
                                    <b style={{ color: "#000000cf" }}>**Key Features of the Computer Lab:**</b>
                                    <b style={{ color: "#000000cf" }}>
                                        <br /> * Sufficient number of latest computers for individual student practice
                                        <br /> * High-speed internet connectivity
                                        <br /> * Updated operating systems and educational software
                                        <br /> * Multimedia facilities including projector and audio system
                                        <br /> * Comfortable seating and proper lighting arrangement
                                        <br />  * Power backup for uninterrupted learning
                                    </b>


                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="about-area ">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-8">
                            <div className="about-right wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <div className="site-heading mb-3">
                                    <h2 className="site-title">
                                        Transport
                                    </h2>
                                </div>
                                <p className="about-text" style={{ textAlign: "justify" }}>
                                    The school provides a safe, reliable, and well-organized transport facility for students coming from different parts of the city and nearby areas
                                    <br />  <b> Well-Maintained Fleet:</b> School buses are regularly serviced and maintained to ensure safety and comfort.
                                    <br /> <b>Safety First: </b> All buses are equipped with speed governors, first-aid kits, and fire safety equipment.
                                    <br /> <b>Experienced Staff: </b> Each bus is driven by a trained, licensed driver and assisted by a conductor/attendant for student safety.
                                    <br /> <b>Fixed Routes & Timings: </b> Buses operate on predefined routes with punctual pick-up and drop-off schedules.
                                    <br /> <b>Student Convenience: </b> Transport facility is available on a first-come, first-served basis and is optional for students.
                                    <br /> <b>Parental Assurance: </b> Parents are informed about routes, stops, and timings for complete transparency.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                <div className="about-img">
                                    <div className="row g-4">
                                        <div className="col-md-12">
                                            <img className="img-2" src="assets/school/Transport.webp" alt />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="about-area ">
                <div className="container">
                    <div className="row g-4 align-items-center">

                        <div className="col-lg-4">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                <div className="about-img">
                                    <div className="row g-4">
                                        <div className="col-md-12">
                                            <img className="img-2" src="assets/school/Medical Facilities.avif" alt />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="about-right wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <div className="site-heading mb-3">
                                    <h2 className="site-title">
                                        Medical Facilities
                                    </h2>
                                </div>
                                <p className="about-text" style={{ textAlign: "justify" }}>
                                    The school gives high priority to the health and well-being of its students and staff. To ensure a safe and healthy learning environment, the following medical facilities are provided:
                                    A well-equipped medical room is available on campus to provide first aid and immediate care during school hours.
                                    A trained nurse/medical attendant is available to handle minor illnesses, injuries, and emergencies.
                                    All classrooms, laboratories, playgrounds, and school buses are equipped with first aid kits.
                                    Periodic health check-ups, including eye, dental, and general health screenings, are organized for students.
                                    In case of serious medical emergencies, students are immediately referred to the nearest hospital, and parents are informed without delay.
                                    Health records of students are maintained to monitor their medical history and special health needs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-area ">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-8">
                            <div className="about-right wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <div className="site-heading mb-3">
                                    <h2 className="site-title">
                                        Science Lab
                                    </h2>
                                </div>
                                <p className="about-text" style={{ textAlign: "justify" }}>
                                    Our school has a well-equipped and spacious Science Laboratory designed to encourage practical learning and scientific thinking among students. The laboratory provides hands-on experience in Physics, Chemistry, and Biology, helping students understand concepts through experiments and observations.

                                    The lab is equipped with modern instruments, charts, models, safety equipment, and sufficient laboratory apparatus as per the curriculum requirements. Proper safety measures are strictly followed, and experiments are conducted under the guidance of trained and experienced teachers.

                                    The Science Laboratory promotes curiosity, creativity, and analytical skills, enabling students to develop a strong foundation in scientific knowledge and practical application.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                <div className="about-img">
                                    <div className="row g-4">
                                        <div className="col-md-12">
                                            <img className="img-2" src="assets/school/Science Lab.jpg" alt />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-area ">
                <div className="container">
                    <div className="row g-4 align-items-center">

                        <div className="col-lg-4">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                <div className="about-img">
                                    <div className="row g-4">
                                        <div className="col-md-12">
                                            <img className="img-2" src="assets/school/Library.jpg" alt />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="about-right wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <div className="site-heading mb-3">
                                    <h2 className="site-title">
                                        Library
                                    </h2>
                                </div>
                                <p className="about-text" style={{ textAlign: "justify" }}>
                                    The school library is a vital learning resource center that supports academic excellence and encourages the habit of reading among students. It provides a calm, well-organized, and student-friendly environment that promotes knowledge, creativity, and self-study.

                                    The library is well-stocked with a wide collection of textbooks, reference books, storybooks, encyclopedias, dictionaries, magazines, newspapers, and competitive exam materials. Books are carefully selected to meet the academic needs of different classes and to enhance general knowledge.

                                    The library follows a proper cataloging and issuing system to ensure smooth access for students and teachers. Regular reading periods are scheduled to cultivate reading habits and improve language skills. Students are encouraged to use the library for project work, research, and self-learning.

                                    Qualified staff manage the library and assist students in selecting books and finding information. The library plays an important role in developing discipline, concentration, and lifelong learning skills among students.

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />


        </>
    )
}

export default Facility